import React from 'react';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import HomePage from "../Routes/HomePage";
import TermsPage from '../Routes/TermsPage';
import ProfilePage from '../Routes/ProfilePage';
import SubscribePage from '../Routes/SubscribePage';
import OtpPage from '../Routes/OtpPage';
import SubscriptionProcessing from '../Routes/SubscriptionProcessing';
import DemoPage from '../Routes/DemoPage';
import LoginPage from '../Routes/LoginPage';
import DeactivateProcessing from '../Routes/DeactivateProcessing';
import DeactivateSuccess from '../Routes/DeactivateSuccess';
import SubscribePage2 from '../Routes/SubscribePage2';
import LoginPage2 from '../Routes/LoginPage2';
import OtpPage2 from '../Routes/OtpPage2';

const Routing = () => {
  const router = createBrowserRouter([
    {
      path: "/home",
      element: <HomePage />
    },
    {
      path: "/terms",
      element: <TermsPage />
    },
    {
      path: "/profile",
      element: <ProfilePage />
    },
    {
      path: "/",
      element: <DemoPage />
    },
    {
      path:"/payment",
      element:<SubscribePage2 />
    },
    {
      path:"/login",
      element:<LoginPage2 />
    },
    {
      path: "/otp",
      element: <OtpPage2 />
    },
    {
      path: "/subscription-processing",
      element: <SubscriptionProcessing />
    },
    {
      path:"/deactivation",
      element:<DeactivateProcessing />
    },
    {
      path:"/deactivation-success",
      element:<DeactivateSuccess />
    },
    {
      path: "*",
      element: <Navigate to="/" />
    }
  ])
  return (
    <RouterProvider router={router} />
  )
}

export default Routing